class MainSearch extends SearchForm {
  constructor() {
    super();

    this.allSearchInputs = document.querySelectorAll('input[type="search"]');

    this.setupEventListeners();

    // Alleen uitvoeren op de volledige zoekresultatenpagina
    this.loadTagResults();
  }

  setupEventListeners() {
    let allSearchForms = [];

    this.allSearchInputs.forEach((input) => {
      if (input.form) {
        allSearchForms.push(input.form);
      }
    });

    if (this.input) {
      this.input.addEventListener('focus', this.onInputFocus.bind(this));
    }

    if (allSearchForms.length < 2) return;

    allSearchForms.forEach((form) => {
      form.addEventListener('reset', this.onFormReset.bind(this));
    });

    this.allSearchInputs.forEach((input) => {
      input.addEventListener('input', this.onInput.bind(this));
    });
  }

  onFormReset(event) {
    super.onFormReset(event);

    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;

    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;

    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }

  async loadTagResults() {
    const productGrid = document.querySelector('#product-grid');

    if (!productGrid) return;

    const urlParams = new URLSearchParams(window.location.search);
    const searchTerm = urlParams.get('q'); 
    
    if (!searchTerm || searchTerm.trim() === '') return;
    
    const tag = searchTerm.trim();
    
    /* * KHZ-artikelnummer: * NOOIT de tag-zoekfunctie uitvoeren. * * Bijvoorbeeld: * KHZ-0906 * KHZ-1117 * KHZ-1234 */ if (/^KHZ-\d+$/i.test(tag)) { return; }
   /* * KHZ-artikelnummers niet als tag zoeken. * Voorbeeld: KHZ-1117 * * Shopify's normale search mag deze wel gewoon * vinden via de verborgen KHZ-code in de beschrijving. */
   
  if (/^KHZ-\d+$/i.test(tag)) { 
    return; 
  } 
  const tagUrl = `/collections/all/${encodeURIComponent(tag)}`;

    try {
      const response = await fetch(tagUrl, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) return;

      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const tagGrid = doc.querySelector('#product-grid');

      if (!tagGrid) return;

      const tagItems = tagGrid.querySelectorAll('li.grid__item');

      if (!tagItems.length) return;

      const currentItems = productGrid.querySelectorAll('li.grid__item');

      /*
       * Verzamel URLs van producten die al via de normale
       * Shopify search gevonden zijn.
       */
      const existingUrls = new Set();

      currentItems.forEach((item) => {
        const link = item.querySelector('a[href*="/products/"]');

        if (!link) return;

        const url = new URL(link.href, window.location.origin);

        existingUrls.add(url.pathname);
      });

      let addedProducts = 0;

      tagItems.forEach((item) => {
        const link = item.querySelector('a[href*="/products/"]');

        if (!link) return;

        const url = new URL(link.href, window.location.origin);
        const productPath = url.pathname;

        // Product bestaat al in de normale zoekresultaten
        if (existingUrls.has(productPath)) return;

        const clone = item.cloneNode(true);

        productGrid.querySelector('ul.product-grid')?.appendChild(clone);

        existingUrls.add(productPath);
        addedProducts++;
      });

      /*
       * Als er tag-resultaten zijn toegevoegd, laten we
       * de bestaande "geen resultaten" melding verdwijnen.
       */
      if (addedProducts > 0) {
        const emptyMessage = document.querySelector(
          '.template-search__results.collection--empty'
        );

        if (emptyMessage) {
          emptyMessage.style.display = 'none';
        }
      }
    } catch (error) {
      console.warn('Tag search kon niet worden geladen:', error);
    }
  }
}

customElements.define('main-search', MainSearch);